import React from 'react'

import { Button, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

function Footer({
  isSignup, canSubmit, locale = 'en', onSwitchMode,
}) {
  const t = key => i18n.t(`auth_modal.${key}`, { ns: 'rails', lng: locale })
  // Prompt strings carry their own trailing space so locales without
  // word spacing (ja, zh-CN) can omit it.
  const switchPrompt = isSignup ? t('switch.already_member') : t('switch.new_here')
  const switchLink = isSignup ? t('switch.log_in') : t('switch.create_account')

  return (
    <div className={classnames(
      'auth-modal__footer',
      isSignup ? 'auth-modal__footer--signup' : 'auth-modal__footer--login'
    )}
    >
      <Button
        actionType="submit"
        size="medium"
        disabled={!canSubmit}
        customClass="auth-modal__submit"
      >
        {t('submit_button')}
      </Button>

      <p className="auth-modal__switch cgt-body-base">
        {switchPrompt}
        <button
          type="button"
          className="auth-modal__switch-link cgt-body-md-semibold cgt-link-primary-accented"
          onClick={onSwitchMode}
        >
          {switchLink}
        </button>
      </p>
    </div>
  )
}

Footer.propTypes = {
  isSignup: bool.isRequired,
  canSubmit: bool.isRequired,
  locale: string,
  onSwitchMode: func.isRequired,
}

export default Footer
